import React, { useState } from 'react';
import { Button, Input, Card, Avatar, Divider, Alert } from '../components/components';
import { Sidebar, Header, Footer, useWindowWidth } from '../layout/layouts';
import { theme } from '../styles/theme';
import { useAuth } from '../contexts/AuthContext';

export const Profile: React.FC = () => {
  const { user } = useAuth();
  const width = useWindowWidth();
  const isMobile = width < 1024;
  const [name, setName] = useState(user?.displayName || 'Anusha Dodla');
  const [email] = useState(user?.email || 'anusha@example.com');
  const [phone, setPhone] = useState('+91 9845012345');
  const [role] = useState(user?.role || 'OWNER');
  const [showAlert, setShowAlert] = useState(false);

  const handleSave = (e: React.FormEvent) => {
    e.preventDefault();
    setShowAlert(true);
    setTimeout(() => setShowAlert(false), 3000);
  };

  return (
    <div style={{ 
      display: 'flex', 
      minHeight: '100vh', 
      backgroundColor: theme.colors.background,
      flexDirection: 'row'
    }}>
      {!isMobile && <Sidebar activeTab="profile" onTabChange={() => {}} userRole={role} />}
      
      <main style={{ 
        flex: 1, 
        padding: isMobile ? theme.spacing.md : theme.spacing.lg, 
        display: 'flex', 
        flexDirection: 'column', 
        boxSizing: 'border-box',
        overflowX: 'hidden'
      }}>
        <Header 
          title="My Account Profile" 
          subtitle="Configure personal credentials and security access tiers."
        />

        {showAlert && (
          <div style={{ marginBottom: theme.spacing.md }}>
            <Alert type="success" title="Profile Saved" message="Your account profile modifications are now securely synchronized!" />
          </div>
        )}

        <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 2fr', gap: theme.spacing.lg, marginTop: theme.spacing.md }}>
          <Card style={{ textAlign: 'center' }}>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <Avatar name={name} size="lg" />
            </div>
            <h2 style={{ marginTop: theme.spacing.md, marginBottom: '4px' }}>{name}</h2>
            <span style={{ fontSize: '12px', color: theme.colors.textSecondary, display: 'block', textTransform: 'uppercase', letterSpacing: '1px' }}>
              {role}
            </span>
            <Divider />
            <div style={{ display: 'flex', flexDirection: 'column', gap: theme.spacing.sm, textAlign: 'left', fontSize: theme.typography.fontSize.xs, color: theme.colors.textSecondary }}>
              <span>🔐 Identity Tier: <strong>SSO OAuth Google</strong></span>
              <span>🏢 Tenant Domain: <strong>{user?.tenantId || 'spectrumjee'}.millish.shop</strong></span>
            </div>
          </Card>

          <Card hoverable={false}>
            <h3>Account Settings</h3>
            <Divider />
            <form onSubmit={handleSave} style={{ display: 'flex', flexDirection: 'column', gap: theme.spacing.md }}>
              <Input label="Full Display Name" value={name} onChange={(e) => setName(e.target.value)} required />
              <Input type="email" label="Verified Email Address" value={email} readOnly disabled />
              <Input label="Contact Phone Number" value={phone} onChange={(e) => setPhone(e.target.value)} />
              <Button type="submit">Commit Settings changes</Button>
            </form>
          </Card>
        </div>
        
        <Footer />
      </main>
    </div>
  );
};

export default Profile;
